import React from "react";
import clsx from "clsx";
import { MenuItemProps } from "./MenuItem";
import SubMenuItem from "./SubMenuItem";

export interface SubMenuProps {
  title: string;
  items: MenuItemProps[];
}

const SubMenu = React.forwardRef(
  (
    props: {
      menu: SubMenuProps[];
      xPos?: number;
    },
    ref: React.Ref<HTMLDivElement>
  ) => {
    const isOutOfScreen = Number(props.xPos) + 280 > document.body.clientWidth;

    return (
      <>
        <div className="min-h-[100vh] min-w-[100vw] fixed top-[54px] left-0 right-0 bg-white bg-opacity-0 z-1"></div>
        <div
          ref={ref}
          className={clsx(
            "fixed bg-white top-[125px] border border-gray-100 shadow-lg p-4 rounded-lg",
            "max-w-[490px] min-w-[490px] flex flex-wrap cursor-default max-h-[80vh] overflow-y-auto z-40"
          )}
          style={{
            left: isOutOfScreen ? "auto" : props.xPos,
            transform: isOutOfScreen ? "" : "translateX(-50%)",
            right: isOutOfScreen ? "10px" : "auto",
          }}
        >
          {props.menu.map((rec, index) => (
            <div key={index} className="mb-[10px] last-of-type:mb-0 w-full">
              {rec.title && (
                <div className="text-gray-400 font-semibold mb-[10px] text-xs">
                  {rec.title}
                </div>
              )}
              {rec.items.map((item, index) => (
                <SubMenuItem key={index} item={item} />
              ))}
            </div>
          ))}
        </div>
      </>
    );
  }
);

export default SubMenu;
